import React, { Component } from 'react';
import ChartToolbar from './chart_toolbar';

class DetailsHeader extends Component {
    
    handleOpenPicker = () => {
        this.props.onChartPicker();
    }

    render() { 
        return ( 
            <div className="chart-header-flex">
                <div>{this.props.displayName}</div>
                <div><ChartToolbar onPickerOpen={this.handleOpenPicker} /></div>
            </div>
         );
    }

}
 
export default DetailsHeader;